const actions = {
  SET_STATE: 'menu/SET_STATE',
  SET_POPUP: 'menu/SET_POPUP',
  // GET_DATA: 'menu/GET_DATA',
  RELOAD: 'menu/RELOAD',
}

export default actions
